// extracted by mini-css-extract-plugin
module.exports = {"form-group":"SearchBar_form-group___rzXv","searchIcon":"SearchBar_searchIcon__rkXjW","search-bar":"SearchBar_search-bar__8jAcX"};